export default class IHDirections {
  
  static extended(core) {
    
    $(core).on('ready', () => {
      
      core.initDirections();
  
      // 現在地マーカを移動させた時に、ルートを再描画する
      $(core.map).on('ihUpdateCenterMarker', () => {
    
        let place = core.getLastClickedPlace();
    
        if (place) {
          
          let marker = core.map.getPlaceMarker(place.id);
          
          if (marker) {
            core.directionFromCurrent(marker);
          }
          
        }
    
      });
      
    });
  
    // ルート描画後、詳細パネルの現在地マーカ〜施設間の距離を更新する
    $(core).on('ihAfterDirection', (event, response) => {
      
      let distance = response.routes[0].legs[0].distance.value; // Google Maps Directions API のレスポンス
      let place = core.getLastClickedPlace();
      
      place.distance = distance;
      
      if (place) {
        core.popupFactory.fillMarkerPopup(place, $('#page-place'));
      }
      
    });
    
    $(core).on('ihClear', () => {
      core.clearDirection();
    });
    
    $(core).on('ihClickMarker', (event, place, marker) => {
      core.directionFromCurrent(marker);
    });
    
  }
  
  initDirections() {
  
    // 管理画面で設定する値
    if (typeof this.show_direction_on_marker_click === 'undefined') {
      this.show_direction_on_marker_click = true;
    }
    
    this.directionTravelMode = 'WALKING'; // WALKING, DRIVING, BICYCLING
    this.directionRendererOptions = {
      suppressInfoWindows: true,
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: '#ed2f6e',
        strokeOpacity: 0.5,
        strokeWeight: 6
      },
      preserveViewport: true
    };
    
    /*
      Direction Service
        経路探索した際に自動でzoomの変更が起こらないようにする（自動変更する際はfalse）
        http://waox.main.jp/news/?p=2125
    */
    this.directionService = this.getService('Direction');
    this.directionsRenderer = this.createDirectionsRenderer();
    
  }
  
  /**
   * 検索位置からマーカーまでのルートを引く
   *
   * @param {type} marker
   * @returns {undefined}
   */
  directionFromCurrent(marker){
    let that = this;
    if (this.show_direction_on_marker_click && marker) {
      this.requestToDirectionService({
        origin: that.map.getCurrentSearchLocation(),
        destination: marker.getPosition()
      })
      .then((response, status) => {
        $(that).trigger('ihAfterDirection', response);
      });
    }
  }
  
  getDirectionsRequestDefault(){
    return {
      travelMode: google.maps.DirectionsTravelMode[this.directionTravelMode],
      language: 'ja'
    };
  }
  
  /**
   *
   * @param {object} request
   * @returns {jQuery.Deferred}
   */
  requestToDirectionService(request, renderer){
    
    if (!renderer){
      renderer = this.directionsRenderer;
    }
    
    request = $.extend(this.getDirectionsRequestDefault(), request);
    let df = $.Deferred();
    
    renderer.setMap(this.map.getMap());
    
    this.directionService.route(request, (response, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        renderer.setDirections(response);
        df.resolve(response, status);
      } else {
        df.reject(response, status);
      }
      
    });
    
    return df;
    
  }
  
  clearDirection(){
    if (this.directionsRenderer) {
      this.directionsRenderer.setMap(null);
    }
  }
  
  createDirectionsRenderer(options){
    options = $.extend(this.directionRendererOptions, options);
    return new google.maps.DirectionsRenderer(options);
  }
  
}


// WEBPACK FOOTER //
// ./map/js/ih/modules/IHDirections.js